import React, { useState, useRef, useEffect } from 'react';
import Icon from './Icon';
import './CategoryFilter.css';

const LocationFilter = ({ locations = [], selectedLocations = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLocationToggle = (locationName) => {
    const isSelected = selectedLocations.includes(locationName);
    const newSelection = isSelected
      ? selectedLocations.filter((l) => l !== locationName)
      : [...selectedLocations, locationName];
    onChange(newSelection);
  };

  const handleSelectAll = () => {
    if (selectedLocations.length === locations.length) {
      onChange([]);
    } else {
      onChange(locations.map((l) => l.name));
    }
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const isAllSelected = selectedLocations.length === locations.length;
  const displayText =
    selectedLocations.length === 0
      ? 'Toutes les localisations'
      : selectedLocations.length === locations.length
      ? `Toutes (${locations.length})`
      : `${selectedLocations.length} sélectionnée${selectedLocations.length > 1 ? 's' : ''}`;

  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <div className="category-filter" ref={dropdownRef}>
      <button
        className={`category-filter-trigger ${
          selectedLocations.length > 0 && selectedLocations.length < locations.length
            ? 'has-selection'
            : ''
        }`}
        onClick={handleToggle}
        type="button"
      >
        <Icon name="MapPin" size={16} />
        <span className="filter-text">{displayText}</span>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={14} />
      </button>

      {isOpen && (
        <div className="category-filter-dropdown">
          <div className="category-filter-header">
            <button className="filter-action-btn" onClick={handleSelectAll} type="button">
              <Icon name={isAllSelected ? 'CheckSquare' : 'Square'} size={16} />
              {isAllSelected ? 'Désélectionner tout' : 'Sélectionner tout'}
            </button>
            {selectedLocations.length > 0 && selectedLocations.length < locations.length && (
              <button
                className="filter-action-btn secondary"
                onClick={handleClearAll}
                type="button"
              >
                <Icon name="X" size={16} />
                Effacer
              </button>
            )}
          </div>

          <div className="category-filter-list">
            {locations.map((location) => {
              const isSelected = selectedLocations.includes(location.name);
              return (
                <label
                  key={location.name}
                  className={`category-filter-item ${isSelected ? 'selected' : ''}`}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => handleLocationToggle(location.name)}
                  />
                  <Icon name={isSelected ? 'CheckSquare' : 'Square'} size={16} />
                  <span className="category-name">{location.name}</span>
                  <span className="category-count">{location.keywordCount}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationFilter;
